import { STATE } from "../../classes/Enum";
import { logItemSelect } from "../../api/events";
import { getImageUrl } from "../../helper/image";
import DeferredImage from "./DeferredImage";
import { useSearch } from "../Context";

const ItemImage = ({state, item, greyscale=false, setSelectedItem, query, maxHeight = null, disableSelection = false}) => {
  const { searchEventId } = useSearch();

    const handleSelect = disableSelection
      ? undefined
      : () => {
          setSelectedItem(item);
          if (item.type === STATE.CARD) {
            logItemSelect(item.id, query, searchEventId);
          }
        };

    if (item.type === STATE.CARD) {
        return (
        <div className={`${state == STATE.OVERVIEW ? 'compact-' : ''}item-img shiny radius`}
        onClick={handleSelect}
        style={{maxHeight: `${maxHeight}px`}}
        >
            <DeferredImage
            className='radius'
            src={getImageUrl(item, false)}
            loading='lazy'
            style={maxHeight !== null ? { maxHeight: `${maxHeight}px` } : {}}
            />
            </div>
        );
    }

    return (
      <div className={`${state === STATE.OVERVIEW ? "" : "item-img-container"}`}
              style={{maxHeight: `${maxHeight}px`}}
               onClick={handleSelect}
      >
        <div className={`${state == STATE.OVERVIEW ? 'compact-' : ''}item-img shiny radius`}>
          <DeferredImage
            src={getImageUrl(item, false)}
            style={maxHeight !== null ? { maxHeight: `${maxHeight}px` } : {}}
          />
        </div>
      </div>
  );

}

export default ItemImage
